import { render, staticRenderFns } from "./kryptLiveLabel.vue?vue&type=template&id=2293e1d4&scoped=true&"
import script from "./kryptLiveLabel.vue?vue&type=script&lang=js&"
export * from "./kryptLiveLabel.vue?vue&type=script&lang=js&"
import style0 from "./kryptLiveLabel.vue?vue&type=style&index=0&id=2293e1d4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2293e1d4",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
